import React, { useState, useEffect } from 'react';
import './InviteModal.css';

function InviteModal({ isOpen, onClose, user }) {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const [referralCode, setReferralCode] = useState(user?.referral_code);

  useEffect(() => {
    if (isOpen) {
      fetchReferralStats();
    }
  }, [isOpen]);

  const fetchReferralStats = async () => {
    try {
      setLoading(true);
      const response = await fetch('/backend/api/auth/referral-stats.php', {
        credentials: 'include'
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setReferrals(data.referrals);
          // Update referral code from API if not already set
          if (data.referral_code && !referralCode) {
            setReferralCode(data.referral_code);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching referral stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const copyInviteLink = () => {
    const link = `https://task.leadersmastermind.eu/register/${referralCode}`;
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const getActivityStatusColor = (status) => {
    switch (status) {
      case 'active':
        return '#10b981';
      case 'moderate':
        return '#FDB022';
      case 'inactive':
        return '#999';
      default:
        return '#999';
    }
  };

  const getActivityStatusText = (status) => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'moderate':
        return 'Moderate';
      case 'inactive':
        return 'Inactive';
      default:
        return 'Unknown';
    }
  };

  if (!isOpen) return null;

  return (
    <div className="invite-modal-overlay" onClick={onClose}>
      <div className="invite-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Invite to MasterTask</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <div className="invite-modal-body">
          {/* Referral Code Section */}
          <div className="referral-code-section">
            <div className="referral-code-label">Your Referral Code</div>
            <div className="referral-code-display">{referralCode || 'N/A'}</div>
          </div>

          {/* Invitation Link Section */}
          <div className="invitation-link-section">
            <div className="invitation-link-label">Invitation Link</div>
            <div className="invitation-link-box">
              <div className="invitation-link-text">
                https://task.leadersmastermind.eu/register/{referralCode}
              </div>
            </div>
            <button 
              className="copy-button" 
              onClick={copyInviteLink}
            >
              {copied ? 'Copied!' : 'Copy Link'}
            </button>
          </div>

          {/* Referral Statistics Section */}
          <div className="referral-stats-section">
            <h3>People who joined using your code</h3>
            
            {loading ? (
              <div className="loading-spinner">Loading...</div>
            ) : referrals.length === 0 ? (
              <div className="empty-state">
                No one has used your referral code yet
              </div>
            ) : (
              <div className="referrals-table">
                <div className="referrals-header">
                  <div className="col-name">Name</div>
                  <div className="col-joined">Joined</div>
                  <div className="col-level">Level</div>
                  <div className="col-status">Status</div>
                </div>
                <div className="referrals-body">
                  {referrals.map((referral) => (
                    <div key={referral.id} className="referral-row">
                      <div className="col-name">{referral.name}</div>
                      <div className="col-joined">{formatDate(referral.joined_date)}</div>
                      <div className="col-level">Level {referral.current_level}</div>
                      <div className="col-status">
                        <span 
                          className="status-badge"
                          style={{ 
                            background: `${getActivityStatusColor(referral.activity_status)}20`,
                            color: getActivityStatusColor(referral.activity_status)
                          }}
                        >
                          {getActivityStatusText(referral.activity_status)}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InviteModal;


